import React, { useState } from 'react';
import 'react-image-crop/dist/ReactCrop.css';
import AppConfig from '@config';
import { CustomizedButton } from '@components/Customized';
import ImageCropPresenter from './ImageCropPresenter';
import {
  makeStyles,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  paper: {
    margin: 0,
    textAlign: 'center',
    width: 480,
    height: 'auto'
  },
  title: {
    textAlign: 'left',
    '& h4': {
      fontWeight: 'bold'
    }
  },
  actions: {
    marginLeft: 'auto',
    padding: '8px 24px',
    '& + button': {
      marginLeft: 12
    }
  }
}));

interface Props {
  state: {
    isOpen: boolean;
    file_key: string;
    file_name: string;
    aspect: number;
  };
  onSubmit: (file: { file_name: string; blob: Blob }) => Promise<boolean>;
  onUpdateProfileImage: (_: any) => void;
  onClose: () => void;
}

const ImageCropDialogPresenter: React.FC<Props> = ({
  state,
  onSubmit,
  onClose
}) => {
  const classes = useStyles();
  const [cropedImageBlob, setCropedImageBlob] = useState();
  const [disabled, setDisabled] = useState(false);

  const onClickComplete = async () => {
    setDisabled(true);
    const result = await onSubmit({
      file_name: state.file_name,
      blob: cropedImageBlob!
    });
    if (result) {
      setDisabled(false);
    } else {
      setDisabled(false);
    }
  };

  return (
    <Dialog open={state.isOpen} classes={{ paper: classes.paper }}>
      <DialogTitle classes={{ root: classes.title }} disableTypography>
        <Typography variant="h4">이미지 편집하기</Typography>
      </DialogTitle>
      <DialogContent>
        <ImageCropPresenter
          aspect={state.aspect}
          cropedImageBlob={cropedImageBlob as any}
          setCropedImageBlob={setCropedImageBlob as any}
          src={`${AppConfig.fileApiUrl}/file/${state.file_key}`}
          onSubmit={onSubmit}
        />
      </DialogContent>
      <DialogActions classes={{ root: classes.actions }}>
        <CustomizedButton
          variant="outlined"
          color="primary"
          size="small"
          disableElevation
          onClick={onClose}
        >
          취소
        </CustomizedButton>
        <CustomizedButton
          variant="contained"
          color="primary"
          size="small"
          disableElevation
          disabled={disabled}
          onClick={() => {
            onClickComplete();
          }}
        >
          등록
        </CustomizedButton>
      </DialogActions>
    </Dialog>
  );
};

export default ImageCropDialogPresenter;
